const InvoicingSetUp = {
  SINGLE_INVOICING: "single-invoicing",
  DEFAULT: "default",
};

export default InvoicingSetUp;
